<template>
    <div class="headermenu">
        <div class="py-0 px-0 container">
            <div class="menubar">
                <div class="d-flex">
                    <v-list class="d-flex ma-0 pa-0">
                        <v-list-item class="flex-grow-0 flex-fill category ma-0 me-5 pa-0">
                            <v-list-item-title @click="showFullCategories" class="mt-1 pointer">
                                <i class="las fs-29" :class="isFullCategories ? 'la-times' : 'la-bars'"></i>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-for="(item, i) in headermenu" :key="i" class="flex-grow-0 flex-fill">
                            <v-list-item-title>
                                <dynamic-link
                                    :to="item.href || item.children?.[0].item?.[0].href || '/'"
                                    :append-class="{ 'text-reset fw-700': $route.path === item.href, 'text-reset fw-500': $route.path !== item.href }"
                                >
                                    <div class="px-2 py-5 me-1 position-relative" @mouseenter="viewSubMenu(i, 'inactive')" @mouseleave="hideSubMenu(i)">
                                        <font :color="item.colors">
                                            <div class="icon-floating"><i class="las lh-1 fs-20" :class="item.icon || ''"></i></div>
                                            <div class="fs-16" v-if="item.children && item.children.length">{{ item.name }}</div>
                                            <div class="fs-16" @mouseenter="hideAllSubMenu()" v-else>{{ item.name }}</div>
                                        </font>
                                    </div>
                                </dynamic-link>
                                <div class="sub_menus" v-bind:ref="'sub_menu' + i" v-on:mouseenter="viewSubMenu(i)" v-on:mouseleave="hideSubMenu(i)" v-if="item.children.length">
                                    <div class="sub-wrapper">
                                        <div class="container cstm-row">
                                            <div class="sub-list">
                                                <div :class="{ 'over-2': item.children.length > 1 }">
                                                    <div v-for="(sub_menu, j) in item.children.filter((c) => !c.demoOnly || demoMode)">
                                                        <h4 v-html="sub_menu.name || item.name"></h4>
                                                        <ul class="position-relative unstyled w-100">
                                                            <li
                                                                v-for="(sub_menu2, k) in sub_menu.item"
                                                                :key="j + '_' + k"
                                                                class="sub-list-menus n h b"
                                                                :class="{ 'no-hover': sub_menu2.children && sub_menu2.children.length }"
                                                                @mouseenter="showMenu($event, sub_menu2.children)"
                                                            >
                                                                <dynamic-link :to="sub_menu2.href || '/'" :class="[sub_menu2.special, 'sub-list-link']">
                                                                    {{ sub_menu2.name }}
                                                                </dynamic-link>
                                                                <!-- <i class="n-icon">N</i> -->
                                                                <!-- <i class="h-icon">H</i> -->
                                                                <!-- <i class="b-icon">B</i> -->
                                                                <img
                                                                    v-if="sub_menu2.children && sub_menu2.children.length"
                                                                    src="/assets/img/menu-arrow.svg"
                                                                    class="sub-menu-arrow"
                                                                />
                                                                <ul v-if="sub_menu2.children && sub_menu2.children.length">
                                                                    <li v-for="(sub_menu3, m) in sub_menu2.children" :key="j + '_' + k + '_' + m" class="n h b">
                                                                        <dynamic-link :to="sub_menu3.href || '/'" :class="[sub_menu3.special, 'sub-list-link2']">
                                                                            {{ sub_menu3.name }}
                                                                        </dynamic-link>
                                                                        <!-- <i class="n-icon">N</i> -->
                                                                        <!-- <i class="h-icon">H</i> -->
                                                                        <!-- <i class="b-icon">B</i> -->
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right-side">
                                                <ul>
                                                    <li v-for="(item, idx) in dummyData[i]">
                                                        <img :src="`/assets/img/dummyImgs/dummy${i}/${idx}.png`" alt="관련 이미지" />
                                                        <h4>{{ item.title }}</h4>
                                                        <ul class="tag-list">
                                                            <li v-for="tag in item.tags.split(',')">{{ tag.trim() }}</li>
                                                        </ul>
                                                        <!-- <dynamic-link :to="item.href">지금 주문하기 +</dynamic-link> -->
                                                    </li>
                                                </ul>
                                                <div>
                                                    <p>
                                                        환경친화적 인쇄를 지향하는
                                                        <br />
                                                        인쇄의 넘버원,
                                                        <strong>프리원!</strong>
                                                    </p>
                                                    <img src="/assets/img/soyinkmark.svg" alt="인증마크" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </div>
                <div class="d-flex align-center right-icons">
                    <div v-for="(menu, i) in $optional('data.logobar_menu?.labels')" :key="i" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="$optional('data.logobar_menu.links')[i]" class="text-reset">
                                    <i class="las" v-bind="attrs" v-on="on" v-bind:class="$optional('data.logobar_menu.icons')[i]">
                                        <v-badge
                                            color="error"
                                            :content="getCartCount"
                                            inline
                                            v-if="getCartCount > 0 && $optional('data.logobar_menu.links')[i] === '/cart'"
                                            class="icon-badge"
                                            style="left: 1325px; top: -12px"
                                        ></v-badge>
                                    </i>
                                </router-link>
                            </template>
                            <span>{{ menu }}</span>
                        </v-tooltip>
                    </div>

                    <div v-if="!isAuthenticated" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="{ name: 'Login' }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-in-alt"></i>
                                </router-link>
                            </template>
                            <span>로그인</span>
                        </v-tooltip>
                    </div>
                    <div v-else class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="{ name: 'Logout' }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-out-alt"></i>
                                </router-link>
                            </template>
                            <span>로그아웃</span>
                        </v-tooltip>
                    </div>
                </div>
            </div>
            <FullCategories :show="isFullCategories" ref="fullCategories" @close="closeFullCategories" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    //import FullCategories from "./FullCategories.vue";
    import FullCategories from '../../../pages/custom/prione/FullCategories.vue';

    export default {
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
                current_path: '',
            },
        },
        watch: {
            // $route 객체를 감시하여 경로가 변경되었는지 확인
            $route(to, from) {
                //console.log('Route changed from', from.path, 'to', to.path);
                this.isFullCategories = false;
            },
        },
        data: () => ({
            isFullCategories: false,
            dummyData: {
                0: [
                    {
                        title: '디지털 무선책자',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/book-digital-wireless',
                    },
                    {
                        title: '디지털 중철책자',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/book-digital-stitch',
                    },
                ],
                1: [
                    {
                        title: '디지털 일반지 포스터',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/poster-digital-general',
                    },
                    {
                        title: '디지털 고급지 포스터',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/poster-poster-premium',
                    },
                ],
                2: [
                    {
                        title: '디지털 무선 카탈로그',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/catalog-digital-wireless',
                    },
                    {
                        title: '디지털 중철 카탈로그',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/catalog-digital-stitch',
                    },
                ],
                3: [
                    {
                        title: '디지털 일반지 리플렛',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/leaflet-digital-general',
                    },
                    {
                        title: '디지털 고급지 리플렛',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/leaflet-digital-premium',
                    },
                ],
                4: [
                    {
                        title: '디지털 일반지 전단지',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/sheet-digital-normal',
                    },
                ],
                5: [
                    {
                        title: '디지털 초대장/안내장',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/card-digital-visit',
                    },
                    {
                        title: '디지털 상품권/티켓',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/card-digital-ticket',
                    },
                ],
                6: [
                    {
                        title: '디지털 엽서',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/card-digital-postcard',
                    },
                ],
                7: [
                    {
                        title: '디지털 고급지 명함',
                        tags: '#빠른 제작, #소량인쇄, #우수한 펼침성, #경제적 가격',
                        href: '/product/businesscard-digital-premium',
                    },
                ],
                8: [
                    {
                        title: '디지털 탁상용 캘린더(세로형)',
                        tags: '#빠른 제작, #소량인쇄, #맞춤형 삼각대',
                        href: '/product/calendar-digital-desktop2',
                    },
                    {
                        title: '디지털 벽걸이용 캘린더',
                        tags: '#빠른 제작, #대량인쇄, #브랜드가치, #경제적 가격',
                        href: '/product/calendar-digital-walltype',
                    },
                ],
                9: [
                    {
                        title: '디지털 낱장인쇄',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/single-sheet-digital-normal',
                    },
                ],
                10: [
                    {
                        title: '실사출력 실외용 배너',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                        href: '/product/stand-banner',
                    },
                    {
                        title: '실사출력 현수막',
                        tags: '#빠른 제작, #고해상도, #경제적 가격',
                        href: '/product/largeformat-hanging-general',
                    },
                ],
            },
            headermenu: [
                //헤더 메뉴 리스트(임시(나중에 db화 해야함))
                {
                    name: '책자',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 책자',
                            item: [
                                {
                                    name: '무선책자',
                                    href: '/product/book-digital-wireless',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '중철책자',
                                    href: '/product/book-digital-stitch',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '트윈링책자',
                                    href: '/product/book-digital-twinring',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '코일링책자',
                                    href: '/product/book-digital-coilring',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                        {
                            type: '',
                            name: '디지털 책자 <span style="font-weight:400;color:#1f63e2;">(고품질잉크젯)</span>',
                            item: [
                                {
                                    name: '무선책자',
                                    href: '/product/digital-perfect-booklet-on-inkjet',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '중철책자',
                                    href: '/product/digital-saddle-booklet-on-inkjet',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '트윈링책자',
                                    href: '/product/digital-twinring-booklet-on-inkjet',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '포스터',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 포스터',
                            item: [
                                {
                                    name: '일반지 포스터',
                                    href: '/product/poster-digital-general',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '고급지 포스터',
                                    href: '/product/poster-digital-premium',
                                    id: '',
                                    class: '',
                                },
                                /***{
                              name: '펄지 포스터',
                              href: '/product/poster-digital-pearl',
                              id: '',
                              class: '',
                          },/***/
                                /***{
                              name: '특수지 포스터',
                              href: '/product/poster-digital-special',
                              id: '',
                              class: '',
                          },/***/
                            ],
                        },
                    ],
                },
                {
                    name: '카탈로그',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 카탈로그',
                            item: [
                                {
                                    name: '무선 카탈로그',
                                    href: '/product/catalog-digital-wireless',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '중철 카탈로그',
                                    href: '/product/catalog-digital-stitch',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '트윈링 카탈로그',
                                    href: '/product/catalog-digital-twinring',
                                    id: '',
                                    class: '',
                                },
                                /***{
                                name: '코일링 카탈로그',
                                href: '/product/catalog-digital-twinring2',
                                id: '',
                                class: '',
                            },***/
                            ],
                        },
                    ],
                },
                {
                    name: '리플렛',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 리플렛',
                            item: [
                                {
                                    name: '일반지 리플렛',
                                    href: '/product/leaflet-digital-general',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '고급지 리플렛',
                                    href: '/product/leaflet-digital-premium',
                                    id: '',
                                    class: '',
                                },
                                /***{
                              name: '펄지 리플렛',
                              href: '/product/leaflet-digital-pearl',
                              id: '',
                              class: '',
                          },***/
                                /***{
                              name: '특수지 리플렛',
                              href: '/product/leaflet-digital-spacial',
                              id: '',
                              class: '',
                          },***/
                            ],
                        },
                    ],
                },
                {
                    name: '전단지',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 전단지',
                            item: [
                                {
                                    name: '전단지',
                                    href: '/product/sheet-digital-normal',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '초대장',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 초대장',
                            item: [
                                {
                                    name: '초대장/안내장',
                                    href: '/product/card-digital-visit',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '상품권/티켓',
                                    href: '/product/card-digital-ticket',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '쿠폰',
                                    href: '/product/card-digital-coupon',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '엽서',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 엽서',
                            item: [
                                {
                                    name: '엽서',
                                    href: '/product/card-digital-postcard',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '명함',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 명함',
                            item: [
                                {
                                    name: '일반지 명함',
                                    href: '/product/businesscard-digital-general',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '고급지 명함',
                                    href: '/product/businesscard-digital-premium',
                                    id: '',
                                    class: '',
                                },
                                /***{
                              name: '펄지 명함',
                              href: '/product/businesscard-digital-pearl',
                              id: '',
                              class: '',
                          },***/
                                /***{
                              name: '특수지 명함',
                              href: "/product/businesscard-digital-special",
                              id: '',
                              class: '',
                          },***/
                            ],
                        },
                    ],
                },
                /*{
              name: '스티커',
              href: '',
              children: [
                  {
                      type: '',
                      name: '디지털 스티커',
                      item: [
                          {
                              name: '재단형 스티커',
                              href: '',
                              id: '',
                              class: '',
                          },
                          {
                              name: '톰슨형 스티커',
                              href: '',
                              id: '',
                              class: '',
                          },
                      ],
                  },
              ],
          },*/
                {
                    name: '캘린더',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 캘린더',
                            item: [
                                {
                                    name: '탁상용 캘린더(가로형)',
                                    href: '/product/calendar-digital-desktop',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '탁상용 캘린더(세로형)',
                                    href: '/product/calendar-digital-desktop2',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '미니 캘린더',
                                    href: '/product/calendar-digital-desktop3',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '벽걸이용 캘린더',
                                    href: '/product/calendar-digital-walltype',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                /*{
              name: '봉투/쇼핑백',
              href: '',
              children: [
                  {
                      type: '',
                      name: '디지털 봉투/쇼핑백',
                      item: [
                          {
                              name: '세로형 기성봉투(규격형)',
                              href: '/product/envelope-digital',
                              id: '',
                              class: '',
                          },
                          {
                              name: '쇼핑백',
                              href: '/product/shoppingbag-digital',
                              id: '',
                              class: '',
                          },
                      ],
                  },
              ],
          },*/
                {
                    name: '낱장인쇄',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '디지털 낱장인쇄',
                            item: [
                                {
                                    name: '낱장인쇄',
                                    href: '/product/single-sheet-digital-normal',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '실사출력',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '실사출력',
                            item: [
                                {
                                    name: '배너',
                                    href: '/product/stand-banner',
                                    id: '',
                                    class: '',
                                    children: [
                                        {
                                            name: '실내용 배너',
                                            href: '/product/stand-banner',
                                            id: '',
                                            class: '',
                                        },
                                        {
                                            name: '실외용 배너',
                                            href: '/product/outdoor-banner',
                                            id: '',
                                            class: '',
                                        },
                                        {
                                            name: '미니 배너',
                                            href: '/product/mini-banner',
                                            id: '',
                                            class: '',
                                        },
                                    ],
                                },
                                {
                                    name: '현수막',
                                    href: '/product/largeformat-hanging-general',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '실사출력',
                                    href: '/product/largeformat-printing-general',
                                    id: '',
                                    class: '',
                                },
                            ],
                        },
                    ],
                },
                /*** {
                    icon: 'la-leaf',
                    colors: '#32a500',
                    name: '친환경인쇄',
                    href: '',
                    children: [
                        {
                            type: '',
                            name: '옵셋 친환경인쇄',
                            item: [
                                {
                                    name: '옵셋 친환경 전단지',
                                    href: '/product/eco-offset-sheet',
                                    id: '',
                                    class: '',
                                },
                                {
                                    name: '프리원의 친환경 인쇄',
                                    href: '',
                                    id: '',
                                    class: '',
                                    special: 'special-green',
                                },
                            ],
                        },
                    ],
                }, /***/
            ],
        }),
        computed: {
            ...mapGetters('cart', ['getCartCount']),
            ...mapGetters('auth', ['isAuthenticated']),
            ...mapGetters('app', ['demoMode']),
        },
        components: {
            FullCategories,
        },
        methods: {
            showFullCategories() {
                this.isFullCategories = !this.isFullCategories;
                // this.hideAllSubMenu();
            },
            closeFullCategories() {
                this.isFullCategories = false;
                // this.hideAllSubMenu();
            },
            viewSubMenu(i, inactive) {
                if (inactive === 'inactive') {
                    const targetMenu = document.querySelector('.active2');
                    if (targetMenu) targetMenu.classList.remove('active2');
                }

                const menuRef = 'sub_menu' + i;
                const element = this.$refs[menuRef][0];

                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    menu.classList.remove('active');
                    // menu.style.display = 'none';
                });

                element.classList.add('active');
                // element.style.display = 'block';

                this.closeFullCategories();
            },
            hideSubMenu(i) {
                const menuRef = 'sub_menu' + i;
                const element = this.$refs[menuRef][0];
                // element.style.display = 'none';
                element.classList.remove('active');

                this.closeFullCategories();
            },
            hideAllSubMenu() {
                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    // menu.style.display = 'none';
                    menu.classList.remove('active');
                });

                this.closeFullCategories();
            },
            showMenu(e, c) {
                if (!c || !c.length) {
                    const activeMenu = document.querySelector('.active2');
                    if (activeMenu) activeMenu.classList.remove('active2');
                } else {
                    e.currentTarget.classList.add('active2');
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .cstm-row {
        display: flex;
    }

    ::v-deep .sub_menus {
        position: absolute;
        left: 0;
        right: 0;
        top: 40px;
        z-index: 1001;
        padding-top: 24px;
        box-shadow: 0px 20px 30px -40px rgb(0 0 0 / 40%);
        transform: scale(0);
        opacity: 0;
        transition:
            opacity 0.5s,
            margin 0.5s,
            transform 0s 0.5s;
        pointer-events: none;

        &.active {
            transform: scale(1);
            margin-top: 0;
            opacity: 1;
            pointer-events: all;

            transition:
                opacity 0.5s,
                margin 0.5s;
        }

        .sub-list {
            h4 {
                margin-bottom: 12px;
            }
        }
    }
    ::v-deep .sub-wrapper {
        border-top: 1px solid #dddddd;
        position: relative;
        box-shadow: 0 -1px 1px #fff;
        padding: 20px 0 60px;

        background-color: #ffffff;

        & > div {
            justify-content: space-between;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .sub-list {
            width: 208px;
            border-right: 1px solid #e5e5e5;
            h3 {
                font-weight: 500;
                font-size: 16px;
                line-height: 130%;
                margin-bottom: 8px;
            }

            & > div {
                white-space: normal;

                &.over-2 > div:first-of-type > ul {
                    padding-bottom: 10px;
                    border-bottom: 2px dotted #e5e5e5;
                    margin-bottom: 10px;
                }

                & > div {
                    position: relative;
                }

                .sub-list-menus {
                    display: flex;
                    align-items: center;

                    .sub-menu-arrow {
                        margin-left: auto;
                        margin-right: 16px;
                    }
                }

                ul ul {
                    display: none;
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translateX(100%);
                    padding-left: 20px;
                }

                ul {
                    display: inline-block;
                    vertical-align: top;

                    li {
                        margin-bottom: 8px;

                        &:not(.no-hover) a:hover {
                            font-weight: 500;
                            &:after {
                                width: 100%;
                            }
                        }

                        &.active2 {
                            .sub-list-link > a {
                                font-weight: 500;
                                &:after {
                                    width: 100%;
                                }
                            }

                            ul {
                                display: block;
                            }
                        }

                        /* &:hover ul{
                          display: block;
                      } */

                        span.special-green {
                            &:after {
                                content: url(/assets/img/header/quick-menu.svg);
                                margin-left: 1px;
                                position: relative;
                                top: 4px;
                            }
                            a {
                                color: #174f19;
                            }
                        }

                        .sub-list-link > a,
                        .sub-list-link2 > a {
                            font-size: 14px;
                            line-height: 100%;
                            color: #000;
                            position: relative;

                            &:after {
                                content: '';
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 0;
                                height: 2px;
                                background: #000;
                                transition: width 0.5s;
                            }
                        }

                        i {
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            align-items: center;
                            justify-content: center;

                            vertical-align: middle;

                            color: #fff;
                            font-size: 7px;

                            font-style: normal;
                            display: none;
                            position: relative;
                            top: -1px;

                            &.h-icon {
                                background: #c20000;
                            }
                            &.n-icon {
                                background: #3e7af2;
                            }
                            &.b-icon {
                                background: #127017;
                            }
                        }

                        &.h {
                            i.h-icon {
                                display: inline-flex;
                            }
                        }
                        &.n {
                            i.n-icon {
                                display: inline-flex;
                            }
                        }
                        &.b {
                            i.b-icon {
                                display: inline-flex;
                            }
                        }
                    }
                }
            }
        }

        .right-side {
            display: flex;
            align-items: flex-start;

            & > ul {
                display: flex;
                margin-right: 47px;

                & > li {
                    width: 300px;
                    margin-right: 10px;

                    &:last-of-type {
                        margin-right: 0;
                    }

                    img {
                        width: 100%;
                        display: block;
                        margin-bottom: 10px;
                    }
                    h4 {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 15px;

                        vertical-align: middle;

                        margin: 0;
                        margin-bottom: 6px;
                    }

                    .tag-list {
                        display: flex;
                        align-items: center;
                        margin-bottom: 5px;

                        li {
                            font-size: 12px;
                            line-height: 13px;

                            vertical-align: middle;
                            margin-right: 10px;

                            &:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }

                    a {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 36px;

                        vertical-align: middle;
                        color: #3e7af2;
                    }
                }
            }
            & > div {
                text-align: right;

                p {
                    font-size: 14px;
                    line-height: 130%;

                    color: #1e5e2a;

                    strong {
                        font-weight: 500;
                    }

                    margin: 0 0;
                }

                img {
                    vertical-align: top;
                }

                a {
                    color: #3e7af2;
                }
            }
        }
    }

    .pointer {
        cursor: pointer;
    }

    .headermenu {
        position: relative;
        height: 64px;
    }
    .headermenu .v-list-item {
        /*서브메뉴 위치때문에*/
        position: static;
    }
    .headermenu .v-list-item + .v-list-item {
        margin-left: 35px;
        /**/
    }
    .headermenu .category {
        text-align: center;
        width: 32px;
        margin-left: -5px !important;
        border: 0 none;
        color: #000;
    }
    .headermenu .category a {
        color: #000;
    }
    .v-list-item {
        padding: 0 !important;
    }

    /* 오른쪽 아이콘 스타일 */
    .right-icons {
        margin-top: -2px;
        margin-right: -4px;
    }
    /* .icon-item {} */
    .icon-item a {
        font-size: 2rem;
        line-height: 1;
        display: block;
        text-align: center;
        margin: 0 4px;
        padding: 4px;
    }
    .icon-badge {
        position: absolute;
        top: -20px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
    .icon-floating {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    .no-href {
        opacity: 0.4;
    }

    .sub-menu-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        color: #000 !important;
    }

    .headermenu {
        .menubar {
            display: flex;
            justify-content: space-between;
            height: 63px;
        }
    }
</style>
